export const AVATAR_COLORS = ['#1570EF','#7839EE','#067647','#B54708','#C11574','#0E7090','#B42318'];

export function avatarColor(name) {
  let h = 0;
  for (let i = 0; i < (name || '').length; i++) h = (name.charCodeAt(i) + ((h << 5) - h)) | 0;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

export function clusterInitial(name) {
  return (name || '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 2).toUpperCase() || '??';
}

export function flagFor(region) {
  if (!region) return '🌍';
  if (region.startsWith('eu-west-2'))    return '🇬🇧';
  if (region.startsWith('eu-west-3'))    return '🇫🇷';
  if (region.startsWith('eu-central'))   return '🇩🇪';
  if (region.startsWith('eu'))           return '🇪🇺';
  if (region.startsWith('us'))           return '🇺🇸';
  if (region.startsWith('ap-southeast')) return '🇦🇺';
  if (region.startsWith('ap-south-1'))   return '🇮🇳';
  if (region.startsWith('ap-northeast')) return '🇯🇵';
  return '🌍';
}
